function executeMain() {
        const swatches = document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_element .bold_option_value');
        
        swatches.forEach((swatch) => {
            appendLearnMoreLink(swatch);
        });
}

function checkClassPresence() {
    let swatches = document.querySelectorAll('.bold_option.bold_option_swatch .bold_option_element .bold_option_value .bold_option_value_element');

    function updateTextVisibility() {
        swatches.forEach((swatch) => {
            const text = swatch.closest('.bold_option_value').querySelector('.bold_custom_text');
            if (swatch.classList.contains('bold_swatch_selected')) {
                text.style.visibility = 'visible';
                text.classList.add('visible');
            } else {
                text.style.visibility = 'visible';
                text.classList.add('visible');
            }
        });
    }

    updateTextVisibility();

    swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
            updateTextVisibility();
        });
    });
      document.querySelectorAll('.bold_option_title').forEach(title => {
  const helpText = title.parentElement.querySelector('.bold_help_text');
  if (helpText && helpText.previousElementSibling !== title) {
    title.insertAdjacentElement('afterend', helpText);
  }
});
}


function appendLearnMoreLink(swatch) {
    if (swatch.querySelector('.bold_custom_text')) return;

    const learnMoreLink = document.createElement('a');
    learnMoreLink.textContent = 'Learn More';
    learnMoreLink.classList.add('bold_custom_text');
    const appendToTitle = swatch.querySelector('.bold_option_value_title');
    // console.log(appendToTitle);
    appendToTitle.appendChild(learnMoreLink);

    learnMoreLink.addEventListener('click', handleLearnMoreClick);
}

// function handleLearnMoreClick(event) {
//     const swatch = event.target.closest('.bold_option_value');
//     const swatchTitle = swatch.querySelector('.bold_option_swatch_title .bold_option_value_title').textContent.trim();
//     console.log('swatch text: ', swatchTitle);

//     const helpTexts = document.querySelectorAll('.bold_option.bold_option_displaytext .bold_help_text');

//     let bestMatch = null;
//     let bestMatchLength = 0;

//     helpTexts.forEach((helpText) => {
//         const helpRawText = helpText.textContent.trim();

//         // Ensure we are matching full text exactly, not just a part of it
//         if (swatchTitle === helpRawText) {
//             bestMatch = helpText;
//             bestMatchLength = helpRawText.length;
//         } else if (swatchTitle.includes(helpRawText) && helpRawText.length > bestMatchLength) {
//             // We only select this if the match is better (i.e., longer help text that matches)
//             bestMatch = helpText;
//             bestMatchLength = helpRawText.length;
//         }
//     });

//     if (bestMatch) {
//         showHelpModal(bestMatch);
//     } else {
//         console.log('No match found for the swatch.');
//     }
// }


function handleLearnMoreClick(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const swatch = event.target.closest('.bold_option_value');
    const swatchTitle = swatch.querySelector('.bold_option_swatch_title .bold_option_value_title').textContent.replace('Learn More','');
    console.log('swatch text: ', swatchTitle);

    const helpTexts = document.querySelectorAll('.bold_option.bold_option_displaytext .bold_help_text');

    let matchFound = false;
    /* New Code Start */
    for(let i=0; i<helpTexts.length;i++){
      const helpRawText = helpTexts[i].textContent;
      if(swatchTitle === helpRawText){
        matchFound = true;
        showHelpModal(helpTexts[i]);
        break;
      }
    }

    if (!matchFound){
      helpTexts.forEach((helpText) => {
        const helpRawText = helpText.textContent;

        if (swatchTitle.includes(helpRawText)) {
            matchFound = true;
            showHelpModal(helpText);
        }
    });
    }
    /* New Code End */
  /*
    helpTexts.forEach((helpText) => {
        const helpRawText = helpText.textContent;

        if (swatchTitle.includes(helpRawText)) {
            matchFound = true;
            showHelpModal(helpText);
        }
    });
  */

    if (!matchFound) {
        console.log('No match found for the swatch.');
    }
}

function append_X() {
const modalContents = document.querySelectorAll('.modal-content');

modalContents.forEach(modalContent => {
    const existingCloseSpan = modalContent.querySelector('.close-btn');
    if (existingCloseSpan) {
        existingCloseSpan.remove();
    }

    const closeSpan = document.createElement('span');
    closeSpan.textContent = 'X';
    closeSpan.onclick = handleCloseClick;

    closeSpan.classList.add('close-btn');

    modalContent.insertBefore(closeSpan, modalContent.firstChild);
});

}

function showHelpModal(helpText) {
    // console.log('Match found');
    
    const modalContainer = helpText.closest('.bold_option.bold_option_displaytext');
    const modal = modalContainer.querySelector('.bold_custom_modal');
    const overlay = modalContainer.querySelector('.site-overlay');

    modalContainer.style.display = 'block';
    overlay.style.display = 'block';
    modal.style.display = 'block';

    setTimeout(() => {
        modalContainer.style.zIndex = '99999';
        modalContainer.style.opacity = '1';
        modal.style.opacity = '1';
        modal.style.transform = 'translate(-50%, -50%) scale(1)';
        overlay.style.opacity = '1';
    }, 10);
}

function add_Evnt_Listeners(event) {
  document.body.addEventListener('click', handleEvent);
  document.body.addEventListener('touchstart', handleEvent);
}

function handleEvent(event) {
  if (event.target.classList.contains('site-overlay') || event.target.classList.contains('bold_custom_modal')) {
    const modalContainer = event.target.closest('.bold_option.bold_option_displaytext');
    const modal = modalContainer.querySelector('.bold_custom_modal');
    const overlay = modalContainer.querySelector('.site-overlay');

    modalContainer.style.opacity = '0';
    modal.style.opacity = '0';
    overlay.style.opacity = '0';

    setTimeout(() => {
      modalContainer.style.display = 'none';
      modal.style.display = 'none';
      overlay.style.display = 'none';
    }, 300);
  }
}


function closeModal() {
    const closeButtons = document.querySelectorAll('.bold_custom_modal .btn.btn-primary');

    closeButtons.forEach((btn) => {
        btn.addEventListener('click', handleCloseClick);
    });
}

function handleCloseClick(event) {
    event.preventDefault();
    const modalContainer = event.target.closest('.bold_option.bold_option_displaytext');
    const modal = modalContainer.querySelector('.bold_custom_modal');
    const overlay = modalContainer.querySelector('.site-overlay');

    modalContainer.style.opacity = '0';
    modal.style.opacity = '0';
    overlay.style.opacity = '0';

    setTimeout(() => {
        modalContainer.style.display = 'none';
        modal.style.display = 'none';
        overlay.style.display = 'none';
    }, 300);
}

function showIfPresent() {
  const swatchTitles = document.querySelectorAll('.bold_option_swatch_title .bold_option_value_title');
  const optionSets = document.querySelectorAll('.bold_option_set');
  
  optionSets.forEach((optionSet) => {
      const helpTexts = optionSet.querySelectorAll('.bold_option.bold_option_displaytext .bold_help_text');
      const customTextElements = optionSet.querySelectorAll('.bold_custom_text');
  
      customTextElements.forEach((element) => {
          element.style.display = 'none';
      });
  
      swatchTitles.forEach((swatchTitle) => {
          const swatchText = swatchTitle.textContent.trim();
          let matchFound = false;
  
          const matched_Val = swatchTitle.querySelector('.bold_option_value_title .bold_custom_text');
  
          helpTexts.forEach((helpText) => {
              const helpRawText = helpText.textContent.trim();
  
              if (swatchText.includes(helpRawText)) {
                  // console.log(matched_Val);
                  matched_Val.style.display = 'block';
                  matchFound = true;
                  // console.log(`Match found: ${swatchText} includes ${helpRawText}`);
              }
          });
  
          if (!matchFound) {
              // console.log(`No match found for: ${swatchText}`);
          }
      });
  });
}


function appendProductPrice() {
      const originalTexts = {};
      
      function updateAddToCartButtons() {
          const productPrice = document.querySelector('[data-price-container] [data-price]')?.textContent.trim();
          
          if (productPrice) {
              const addToCartButtons = document.querySelectorAll('.product__container--two-columns .product-main .product-form .atc-button--text');
              
              addToCartButtons.forEach(button => {
                  const buttonElement = button;
                  const buttonKey = buttonElement.dataset.addToCartText;
      
                  if (!originalTexts[buttonKey]) {
                      originalTexts[buttonKey] = buttonElement.textContent;
                  }
                  
                  buttonElement.textContent = `${originalTexts[buttonKey]} • ${productPrice}`;
              });
          }
      }
      
      const priceElement = document.querySelector('[data-price-container]');
      
      if (priceElement) {
          const observer = new MutationObserver(updateAddToCartButtons);
      
          observer.observe(priceElement, { childList: true, subtree: true, characterData: true });
      
          updateAddToCartButtons();
      }
}



  function initMutationObserver() {
  const targetNode = document.body;
  const observerOptions = {
    childList: true,
    subtree: true,
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let form = document.querySelector('.shopify-product-form');
        let form_bold = document.querySelector('.bold_options.bold_options_loaded');
        let bold_options = document.querySelector('.bold_option_set');

        if ((form && form_bold) || bold_options) {
          // console.log(`Class "${form?.className}" and "${form_bold?.className}" or "${bold_options?.className}" are now present in the DOM.`);
          executeMain();
          closeModal();
          setTimeout(() => {
            checkClassPresence();
            showIfPresent();
          }, 500);
        }
      }
    }
  });

  observer.observe(targetNode, observerOptions);
}
  
document.addEventListener('DOMContentLoaded', initMutationObserver);

function executeScriptWhenClassFound() {
    appendProductPrice();
}
function periodicallyCheckClassPresence() {
    const targetClass = 'bold_options';
    const targetElement = document.querySelector('.' + targetClass);
    if (targetElement) {
        console.log('Class "' + targetClass + '" is now present in the DOM.');
        // If class found, execute the script
        executeScriptWhenClassFound();
        add_Evnt_Listeners();
        // Stop checking once the class is found
        clearInterval(checkInterval);
        append_X();
    } else {
        console.log('Loading...');
    }
}
const checkInterval = setInterval(periodicallyCheckClassPresence, 1000);